import { type FC, memo } from 'react';

export type CloudPeeringDetailData = {
  cloudProvider: string | null;
  peeringId: string | null;
  cloudNetworkId: string | null;
  remoteNetworkId: string | null;
  name: string | null;
};

interface Props {
  firstColumnClassName?: string;
  secondColumnClassName?: string;
  tableClassName?: string;
  tableData: CloudPeeringDetailData;
}

const BareCloudPeeringDetailContent: FC<Props> = (props) => {
  return (
    <table className={props.tableClassName}>
      <tbody>
        <tr>
          <td className={props.firstColumnClassName}>Cloud provider</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.cloudProvider}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Peering ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.peeringId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Cloud network ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.cloudNetworkId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Remote network ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.remoteNetworkId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Name</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.name}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export const CloudPeeringDetailContent = memo(BareCloudPeeringDetailContent);
